import './checkout.css';
import { CartProvider } from "../../context/CartContext";
import { Provider as BusProvider } from 'react-bus';
import { CheckoutProvider, useCheckout } from "../../context/CheckoutContext";
import { useEffect, useRef } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import { Link } from "react-router-dom";
import { CheckoutDelivery } from '../../components/CheckoutDelivery/CheckoutDelivery';
import { BusinessProvider } from '../../context/BusinessContext';
import { CheckoutContact } from '../../components/CheckoutContact/CheckoutContact';
import { CheckoutPaymentsWrapper } from '../../components/CheckoutPayments/CheckoutPayments';
import { CheckoutConfirmation } from '../../components/CheckoutConfirmation/CheckoutConfirmation';
import { CheckoutOrderSummary } from '../../components/CheckoutOrderSummary/CheckoutOrderSummary';

export const CheckoutWrapper = () => {
    return (
        <BusProvider>
            <BusinessProvider>
                <CartProvider>
                    <CheckoutProvider>
                        <Checkout />
                    </CheckoutProvider>
                </CartProvider>
            </BusinessProvider>
        </BusProvider>  
    );
}

const Checkout = () => {
    const { stripeSettings } = useCheckout();

    //REFS
    const stripePromise = useRef(null);

    //EFFECTS
    useEffect(() => {
        if (stripeSettings !== null && stripeSettings.public_key !== "" && stripeSettings.enable)
        {
            stripePromise.current = loadStripe(stripeSettings.public_key);
        }
    }, [stripeSettings]);

    return (
        <>
            <Elements stripe={stripePromise.current}>
                <div className='checkout_app'>
                    <div className='title'>
                        <Link to={'/'}>
                            <i className="fa-solid fa-chevron-left"></i>
                        </Link>
                        <h1>Checkout</h1>
                    </div>
                    <div className='checkout_container'>
                        <div className='checkout_form'>
                            <div className='checkout_form_container'>
                                <CheckoutDelivery />
                                <CheckoutContact />
                                <CheckoutPaymentsWrapper />
                                <CheckoutConfirmation />
                            </div>
                        </div>
                        <div className='checkout_summary'>
                           <CheckoutOrderSummary />
                        </div>
                    </div>
                </div>
            </Elements>
        </>
    );
}